import { ArchiveRestoreRequestQuery } from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import t from '../../i18n/I18n';
import { showSuccessMsg } from '../../store/StoreUtil';
import { createNewArchiveRestoreWebRequestMessage } from './Archive-restore-util';

export class RestoreQuery {
  constructor(hiResStatus, midResStatus, lowResStatus, directStatus, fuidSet, isBackUpRestoreCall) {
    this.hiResStatus = hiResStatus;
    this.midResStatus = midResStatus;
    this.lowResStatus = lowResStatus;
    this.directStatus = directStatus;
    this.fuidSet = fuidSet;
    this.isBackUpRestoreCall = isBackUpRestoreCall;
  }

  run(onRefreshPWD?: function) {
    const query = new ArchiveRestoreRequestQuery();
    const msg = createNewArchiveRestoreWebRequestMessage(
      1,
      this.fuidSet,
      'RESTORE-VAB',
      this.hiResStatus,
      this.midResStatus,
      this.lowResStatus,
      this.directStatus,
      '',
      null,
      true,
      this.isBackUpRestoreCall
    );
    query.message = msg;
    query.run().then(
      (resp) => {
        if (onRefreshPWD)
          onRefreshPWD();
        showSuccessMsg(t('RESTORE_SUCCESS'));
      },
      (failedResp) => {
        ErrorHandler.handleError(failedResp);
      }
    );
  }
}
